import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import SentryManager from '@widgets/sentry-manager';
SentryManager.init();

import initWidgets from '@widgets';
import logger from '@widgets/logger';
import reportUncaughtError from '@widgets/uncaught-error';

initWidgets();

import App from 'App';
import { store } from 'store';
import { setActiveAccountId } from '@helpers/auth';
import { accountsService } from '@services/accounts';
import { registerServiceWorker, initInstallPrompt } from '@services/serviceWorker';
import './index.css';

const invitedAccountId = Number(new URLSearchParams(window.location.search).get('accountId'));
if (Number.isInteger(invitedAccountId) && invitedAccountId > 0) {
    setActiveAccountId(invitedAccountId);

    const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
    if (storedUser?.token) {
        accountsService.setActiveAccount(invitedAccountId).catch(() => {});
    }
}

function AppWithCallbackAfterRender() {
    useEffect(() => {
        logger.success('Pluspoint rendered');
    });

    return (
        <Provider store={store}>
            <App />
        </Provider>
    );
}

const container = document.getElementById('app');
const root = createRoot(container, { onUncaughtError: reportUncaughtError });
root.render(<AppWithCallbackAfterRender />);

registerServiceWorker();
initInstallPrompt();
